import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import YourSunlitSanctuary from "./sections/YourSunlitSanctuary";
import TheCleaningMenu from "./sections/TheCleaningMenu";
import TheSparkleStandard from "./sections/TheSparkleStandard";
import VoicesOfSatisfaction from "./sections/VoicesOfSatisfaction";
import ReadyForAFreshStart from "./sections/ReadyForAFreshStart";
import FooterEssentials from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <YourSunlitSanctuary />
      <TheCleaningMenu />
      <TheSparkleStandard />
      <VoicesOfSatisfaction />
      <ReadyForAFreshStart />
      <FooterEssentials />
    </div>;
}